import React from 'react';
import { initiatePhonePePayment, PhonePePrefillDetails } from './PhonePeClient';

interface PhonePeButtonProps {
  amountRupees: number;
  prefill?: PhonePePrefillDetails;
  onError?: (err: unknown) => void;
}

const buildPhonePeRedirectUrl = () => {
  const url = new URL('/checkout', window.location.origin);
  url.searchParams.set('paymentProvider', 'phonepe');
  return url.toString();
};

const createClientOrderId = () => {
  return `PP_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
};

const resolvePhonePeRedirectUrl = (response: any): string | null => {
  return (
    response?.redirectUrl ||
    response?.redirectURL ||
    response?.data?.redirectUrl ||
    response?.data?.redirectURL ||
    response?.data?.data?.redirectUrl ||
    response?.data?.data?.redirectURL ||
    null
  );
};

const PhonePeButton: React.FC<PhonePeButtonProps> = ({
  amountRupees,
  prefill,
  onError,
}) => {
  const handlePay = async () => {
    try {
      const redirectUrl = buildPhonePeRedirectUrl();
      const merchantOrderId = createClientOrderId();

      const response = await initiatePhonePePayment({
        amountRupees,
        currency: 'INR',
        redirectUrl,
        merchantOrderId,
        prefillUserLoginDetails: prefill?.contact
          ? { phoneNumber: prefill.contact }
          : undefined,
        customerDetails: prefill,
      });

      const resolvedRedirectUrl = resolvePhonePeRedirectUrl(response);

      if (!resolvedRedirectUrl) {
        throw new Error('PhonePe did not return a payment portal redirect URL.');
      }

      sessionStorage.setItem(
        'phonepe-payment-pending',
        JSON.stringify({
          merchantOrderId: response.merchantOrderId || merchantOrderId,
          orderId: response.orderId,
          redirectUrl: resolvedRedirectUrl,
        })
      );

      window.location.assign(resolvedRedirectUrl);
    } catch (error) {
      console.error('PhonePe payment init error:', error);
      onError?.(error);
    }
  };

  return (
    <button
      type="button"
      id="phonepe-btn"
      className="btn btn-warning py-2 px-4"
      onClick={handlePay}
    >
      Pay with PhonePe ₹{amountRupees.toFixed(2)}
    </button>
  );
};

export default PhonePeButton;